module.exports = __webpack_public_path__ + "media/images/instruction/step-four-5de7c2dab37941ce5aa72d82f354b1c7.svg";